<template>
  <div class="expired-files-container clipboard-body">
    <el-card class="expired-files-card">
      <div class="expired-function-container">
        <div class="search-box">
          <el-autocomplete class="autocomplete" v-model="querySearch" :fetch-suggestions="querySearchAsync" placeholder="请输入内容..." @select="handleSelect" :debounce="600" :trigger-on-focus="false" select-when-unmatched highlight-first-item value-key="filename">
            <i class="el-icon-search icon" slot="prefix">
            </i>
          </el-autocomplete>
          <el-divider class="hr"></el-divider>
          <el-tooltip class="search-btn" effect="dark" content="重置数据" placement="bottom">
            <i class="el-icon-refresh-right icon refresh-icon" @click="refleshData"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" placement="left-start">
            <div slot="content">
              <p>页面操作需知：</p>
              <p><span class="color-red">*</span>1. 文件上传：点击/拖拽上传文件，注意在该页面上传的文件都有过期时间。</p>
              <p><span class="color-red">*</span>2. 文件搜索：默认根据文件名称和文件路径模糊搜索文件。</p>
              <p><span class="color-red">*</span>3. 重置过期时间：默认将文件重新上传，从而更新文件生命周期（只能重置CDN资源存在的文件，在此页面检测到CDN不存在的文件，默认将文件状态置为已删除状态）。</p>
              <p><span class="color-red">*</span>4. 复制粘贴上传文件：
                <br /><br /> （1）window系统操作：Ctrl+C => Ctrl+V。
                <br /><br /> （2）Mac系统操作：Command+C => Command+V
                <br /><br /> （3）存储规则：截屏文件自动存储hash名称，其他文件遵循XPS上传规则。
                <br /><br /> （4）使用范围：首页（/fileUpload）、项目详情页面（/fileManage/projectDetail）、过期文件页面（/myFiles）。
              </p>
              <p><span class="color-red">*</span>5. 文件存储时间：
                <br /><br /> （1）选择对应存储天数：默认文件存储时间为360天，计算规则：从文件上传当天开始，360天之后会自动删除文件。
                <br /><br /> （2）存储时间选择范围：360天、720天、1080天。如需要更多的存储时间规则：请联系前端效能组。
                <br /><br /> （3）业务线用户须知：属于业务线的项目用户，如果图片要长期保存，建议在XPS文件管理中创建自己的项目，来管理业务线的文件。
              </p>
            </div>
            <i class="el-icon-info icon info-icon"></i>
          </el-tooltip>

        </div>
        <div class="function-card-box">
          <div class="days-box">
            <div v-for="item in days" :key="item" class="days-card" :class="{'active':item===360}" @click="changeDay($event,item)">
              <strong class="title">Day{{item}}</strong>
              <p class="desc">文件存储{{item}}天</p>
              <p class="count">{{dayFilesCount[`day${item}`]||0}} files</p>
            </div>
          </div>
          <div class="upload-box">
            <el-upload ref="xps-upload" class="xps-upload" name="file_data" drag :multiple="true" action="/api/uploadCos" :show-file-list="false" :data="{day}" :on-success="uploadSuccess">
              <i class="el-icon-upload upload-icon"></i>
              <p class="el-upload__text">将文件拖到此处，或<em>点击上传</em></p>
              <p class="el-upload__tip">当前支持上传所有文件类型，上传文件存储时间：{{`${day}天`}}</p>
            </el-upload>
          </div>
        </div>
      </div>
      <div class="expired-table-container">
        <el-table :data="tableData" style="width: 100%" :height="tableHeight" :highlight-current-row="true">
          <div slot="empty" class="empty-content empty-image">
            <p class="empty-text">将要过期和已过期的文件在此处搜索哦~</p>
          </div>
          <el-table-column label="文件名称" prop="fileName" show-overflow-tooltip min-width="180px" sortable>
            <template v-slot="{row}">
              <div class="file-content file-page-container">
                <img class="file-image" v-if="row.isImg&&!row.isReject" :src="row.url" fit="contain" @error="imgOnError($event,row.id)" />
                <div v-if="!row.isImg&&!row.isReject" class="file-image file-icon" :class="`file-icon-${row.ext}`"></div>
                <img v-if="row.isReject" class="file-image" src="https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png" fit="contain" title="文件已删除" />
                <span class="file-name">{{row.filename}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="CDN地址" prop="url" show-overflow-tooltip min-width="400px" sortable>
            <template v-slot="{row}">
              <span title="复制" class="table-cdn" v-clipboard:copy="row.url" v-clipboard:success="onCopy">{{row.url}}</span>
            </template>
          </el-table-column>
          <el-table-column label="上传时间" prop="createTime" width="150px" sortable>
            <template v-slot="{row}">
              {{row.createTime?formatTime(row.createTime):''}}
            </template>
          </el-table-column>
          <el-table-column label="修改时间" prop="updateTime" width="150px" sortable>
            <template v-slot="{row}">
              {{row.updateTime?formatTime(row.updateTime):''}}
            </template>
          </el-table-column>
          <el-table-column label="失效时间" prop="expiredTime" width="150px" sortable>
          </el-table-column>
          <el-table-column label="剩余天数" prop="oddTime" width="100px" sortable>
          </el-table-column>
          <el-table-column align="center" fixed="right" min-width="110px">
            <template slot="header" slot-scope="scope">
              <el-input v-model="search" size="mini" placeholder="输入关键字搜索" />
            </template>
            <template v-slot="{row}">
              <el-button type="text" @click="resetExpiredTime(row)">重置过期时间</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination class="find-container-pager" @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="pageConfig.pageNum" :page-sizes="[10, 50, 100, 200]" :page-size="pageConfig.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" :pager-count="5">
        </el-pagination>
      </div>
    </el-card>
  </div>

</template>

<script>
import dayjs from 'dayjs';
import axios from 'axios';
import { getExt, isImg } from '@/common/utils/ext.js';
import { myFilesApi, xpsApi } from '@/api/index';
import { showLoading, hideLoading } from '@/plugins/loading';
import { getNumberName } from '@/common/utils/getHashName.js';
export default {
  data () {
    return {
      findFileList: [], // 查询文件列表
      fileList: [], // 复制粘贴上传文件列表
      // 分页查询参数
      pageConfig: {
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      day: 360,
      days: [360, 720, 1080],
      search: '',
      querySearch: '',
      errorImg: 'https://front-xps-cdn.xsyx.xyz/custom/xps/images/delete.png',
      errorId: '',
      file: '',// 文件对象
      path: '',//文件上传路径
      dayFilesCount: '',//我的对应存储日期文件数量
      tableHeight: '400px'
    }
  },
  computed: {
    tableData () {
      return this.findFileList.filter(data => !this.search || data.filename.toLowerCase().includes(this.search.toLowerCase()));
    }
  },
  mounted () {
    this.getExpiredFiles();
    this.bindPaste();
    this.getMyExpiredFilesCount();
    this.$nextTick(() => {
      this.tableHeight = `${document.body.clientHeight && document.documentElement.clientHeight - 472}px`;
    })
    window.addEventListener('resize', () => {
      this.onWindowResize();
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.onWindowResize();
    });
  },
  methods: {
    // 监听窗口变化
    onWindowResize () {
      this.$nextTick(() => {
        this.tableHeight = `${document.body.clientHeight && document.documentElement.clientHeight - 472}px`;
      })
    },
    // 获取我过期文件的数量
    async getMyExpiredFilesCount () {
      const res = await myFilesApi.getMyExpiredFilesCount()
      if (res.code === 200) {
        this.dayFilesCount = res.data;
      }
    },
    // 上传成功的钩子
    uploadSuccess () {
      this.$message.success('文件上传成功！')
      this.getExpiredFiles();
      this.getMyExpiredFilesCount();
    },
    // 获取当前文件对象
    getCurrentFile (uid) {
      return this.fileList.find(item => {
        return item.uid === uid;
      })
    },
    //绑定粘贴事件
    bindPaste () {
      //定义变量存储获取的图片内容
      let file = null;
      //获取clipboardBody对象
      let clipboardBody = document.querySelector(".clipboard-body");
      //定义clipboardBody标签绑定的粘贴事件处理函数
      let fun = async (e) => {
        //获取clipboardData对象
        let data = e.clipboardData || window.clipboardData;
        let date = + new Date();
        //获取文件对象
        file = data.items[0].getAsFile();
        //判断文件是否存在
        if (file && file.size) {
          const day = this.day ? '/custom/day' + this.day + '/' : '';
          const uid = getNumberName(`${day}${file.name}${file.size}`) // 以文件名称、文件大小作为文件id
          // 判断粘贴板的文件是否是截屏
          if (file.name === 'image.png') {
            // 以时间戳重新命名文件
            file = new File([file], `${getNumberName(date)}.png`);
          }
          // 判断文件是否已经上传
          const currentFile = this.getCurrentFile(uid);
          // 如果已经上传 返回
          if (currentFile) {
            return this.$message.warning('当前文件已经上传了哦~');
          }
          // 添加到文件列表中
          this.fileList.push({ uid });
          // 上传服务器
          const form = new FormData();
          // 文件对象
          form.append("file_data", file);
          form.append("day", this.day);
          let data = await xpsApi.uploadCos(form);
          if (data) {
            this.getExpiredFiles();
            this.getMyExpiredFilesCount();
            return this.$message.success('文件上传成功！');
          } else {
            return this.$message.error('文件上传出错啦！！');
          }
        } else {
          this.$message.warning('不支持复制空文件或文件夹哦~');
        }
      }
      //通过clipboardBody绑定粘贴事件
      clipboardBody.removeEventListener('paste', fun);
      clipboardBody.addEventListener('paste', fun);
    },
    // 选择天数卡片触发
    changeDay (e, day) {
      this.selectActiveCard(e);
      this.day = day;
      this.getExpiredFiles()
    },
    // 选中活跃卡片
    selectActiveCard (e) {
      const dom = e.currentTarget;
      const dayCard = document.querySelector('.days-card.active');
      if (dayCard) dayCard.classList.remove('active');
      dom.classList.add('active');
    },
    // 重置数据
    refleshData () {
      this.querySearch = '';
      this.getExpiredFiles();
    },
    async querySearchAsync (queryString, cb) {
      await this.getExpiredFiles();
      cb(this.findFileList);
    },
    handleSelect (item) {
      this.queryString = item;
      this.getExpiredFiles();
    },
    //图片损毁时触发
    imgOnError (e, id) {
      let img = e.srcElement;
      img.title = '图片资源已失效';
      img.src = this.errorImg;
      if (this.errorId !== id) this.deleteExpiredFile(id);
      this.errorId = id;
      img.onerror = null; //防止闪图
    },
    // 重置过期时间
    async resetExpiredTime (row) {
      // 获取参数
      const { url, id } = row;
      // 请求文件对象 Blob
      try {
        const res = await axios.get(url, { responseType: 'blob' });
        if (res.status === 200) {
          // 获取content-type
          let type = res.headers['content-type'];
          // 创建blob对象
          let blob = new Blob([res.data], { type: `${type};charset=utf-8` });
          // 获取文件名称
          let fileName = decodeURI(url.substring(url.lastIndexOf('/') + 1));
          // 获取文件存储路径
          let fPathArr = url.split('https://front-xps-cdn.xsyx.xyz');
          if (fPathArr.length <= 1) {
            fPathArr = url.split('https://uat-xps-cdn.xsyx.xyz')
          }
          let path = fPathArr[1];
          this.path = path.substring(0, path.lastIndexOf('/') + 1);
          // 转换为file对象
          this.file = new File([blob], fileName, { type });
          // 重置文件
          this.resetExpiredFile(id);
        }
      } catch (error) {
        this.deleteExpiredFile(id);
      }
    },
    // 重置过期文件
    async resetExpiredFile (id) {
      // 上传服务器
      const form = new FormData();
      // 文件对象
      form.append("file_data", this.file);
      form.append("path", this.path);
      form.append("id", id);
      const res = await myFilesApi.resetExpiredFile(form);
      if (res.code === 200) {
        this.getExpiredFiles();
        this.$message.success(res.message);
      } else {
        this.$message.error(res.message);
      }
    },
    // 删除失效文件
    async deleteExpiredFile (id) {
      await myFilesApi.deleteExpiredFile({ id })
    },
    // 查询过期文件列表
    async getExpiredFiles () {
      showLoading();
      const res = await myFilesApi.getExpiredFiles({ day: this.day, querySearch: this.querySearch, ...this.pageConfig });
      if (res.code === 200) {
        if (res.data.length > 0) {
          res.data.forEach(item => {
            item.isImg = isImg(item.url);
            item.ext = getExt(item.url);
            item.expiredTime = this.expiredTime(item.updateTime);
            item.oddTime = this.oddTime(item.updateTime);
          })
        }
        this.findFileList = res.data;
        this.total = res.total;
      } else {
        this.$message.error(res.message);
      }
      hideLoading();
    },
    // 复制
    onCopy () {
      this.$message.success('文件地址复制成功', 2);
    },
    // 当当前页数改变，触发事件
    handlePageChange (num) {
      this.pageConfig.pageNum = num;
      this.getExpiredFiles();
    },
    // 当页面显示数据总数改变，触发事件
    handleSizeChange (size) {
      this.pageConfig.pageSize = size;
      this.getExpiredFiles();
    },
    // 格式化时间
    formatTime (time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss');
    },
    // 失效时间
    expiredTime (time) {
      const t = +new Date(time) + this.day * 24 * 60 * 60 * 1000;
      return this.formatTime(t)
    },
    // 剩余时间
    oddTime (time) {
      const oneDay = 24 * 60 * 60 * 1000;
      const currentTime = +new Date();
      const createTime = +new Date(time);
      return `${this.day - Math.floor((currentTime - createTime) / oneDay)}天`;
    }
  }
}
</script>

<style lang="scss">
.expired-files-container {
  margin-bottom: 10px;
  height: 100%;
  .expired-files-card {
    height: 100%;
    overflow-y: auto;
    .expired-function-container {
      height: 270px;
      .search-box {
        position: relative;
        .icon {
          margin-left: 5px;
          font-size: 24px;
          line-height: 48px;
          color: #c0c4cc;
          &.refresh-icon {
            position: absolute;
            right: 10px;
            top: 0;
            cursor: pointer;
            z-index: 100;
          }
          &.info-icon {
            position: absolute;
            right: 40px;
            top: 0;
            cursor: pointer;
            z-index: 100;
          }
        }
        .autocomplete {
          width: 100%;
          .el-input__inner {
            font-size: 24px;
            border: 0 !important;
            height: 48px;
            line-height: 48px;
            padding-left: 48px;
          }
        }
        .hr {
          margin: 12px 0;
        }
      }
      .function-card-box {
        display: flex;
        justify-content: space-between;
        .days-box {
          display: flex;
          width: 60%;
          .days-card {
            margin-right: 1.3%;
            padding: 20px;
            width: 32%;
            height: 180px;
            background: #fbfbfb;
            border-radius: 10px;
            cursor: pointer;
            transition: all 0.3s;
            // background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-gray-bg.webp");
            background-repeat: no-repeat;
            &.active {
              background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-bg.webp");
              .title {
                color: #041677;
              }
            }
            &:hover {
              background-color: #f7f6f9;
            }
            .desc {
              color: #9d9da8;
            }
            .count {
              font-size: 14px;
              color: #9d9da8;
            }
          }
        }
        .upload-box {
          width: 35%;
          .xps-upload {
            .el-icon-upload {
              margin: 30px 0 0 0;
            }
            .el-upload-dragger {
              height: 180px;
              border: 0;
              background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-gray-bg.webp");
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
              &:hover {
                background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/upload-bg.webp");
              }
            }
          }
        }
      }
    }
    .expired-table-container {
      position: relative;
      overflow: auto;
      height: calc(100% - 250px);
      .empty-content.empty-image {
        height: 400px;
        background-size: 60%;
        background-image: url("https://front-xps-cdn.xsyx.xyz/custom/xps/images/file-destroy.png");
        background-repeat: no-repeat;
        background-position: center;
      }
      .empty-text {
        position: relative;
        top: 300px;
        font-weight: 500;
        color: #bcbcbc;
      }
      .file-content {
        display: flex;
        justify-content: left;
        align-items: center;
        .file-image {
          display: inline-block;
          margin-right: 20px;
          width: 40px;
          max-height: 40px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          &.file-icon {
            height: 40px;
            margin-bottom: 0;
          }
        }
      }
      .find-container-pager {
        margin-top: 15px;
        text-align: center;
      }
      .table-cdn {
        cursor: pointer;
        &:hover {
          color: #409eff;
        }
      }
    }
  }
}
</style>